"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Card = /** @class */function (_super) {
  __extends(Card, _super);
  function Card() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Card.prototype.render = function () {
    return react_1.default.createElement("div", {
      className: "bg-white overflow-hidden shadow rounded-lg"
    }, react_1.default.createElement("div", {
      className: "p-5"
    }, react_1.default.createElement("div", {
      className: "flex"
    }, react_1.default.createElement("div", {
      className: "flex-shrink-0"
    }, react_1.default.createElement("span", {
      className: "flex p-2 mt-1 rounded-lg bg-primary-500"
    }, this.props.icon)), react_1.default.createElement("div", {
      className: "ml-5 w-0 flex-1"
    }, react_1.default.createElement("dl", null, react_1.default.createElement("dt", {
      className: "text-md font-medium text-gray-500 truncate"
    }, this.props.title), react_1.default.createElement("dd", null, react_1.default.createElement("p", {
      className: "text-xs font-medium text-gray-500 truncate"
    }, this.props.description), react_1.default.createElement("div", {
      className: "text-lg font-medium text-gray-900 mt-2"
    }, this.props.count)))), this.props.tool)));
  };
  return Card;
}(react_1.Component);
exports.Card = Card;